/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferZoomIn
 */
export interface OfferZoomIn {
    /**
     * 
     * @type {number}
     * @memberof OfferZoomIn
     */
    zoom?: number;
}

export function OfferZoomInFromJSON(json: any): OfferZoomIn {
    return OfferZoomInFromJSONTyped(json, false);
}

export function OfferZoomInFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferZoomIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zoom': !exists(json, 'zoom') ? undefined : json['zoom'],
    };
}

export function OfferZoomInToJSON(value?: OfferZoomIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zoom': value.zoom,
    };
}


